/* tslint:disable */
/* eslint-disable */
/**
 * Unnamed Galvyn API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddDnsSearchDomainRequest,
  AddExtraDnsRecordRequest,
  AddExtraDnsRequest,
  ApiErrorResponse,
  CreateAccessRuleRequest,
  CreateLocalGroupRequest,
  CreatePreAuthKeyRequest,
  CreatePreAuthKeyResponse,
  CreateSplitDnsDomainRequest,
  CreateSplitDnsResolverRequest,
  CreateTagRequest,
  DeviceFromIpResponse,
  EnableSubnetRequest,
  FormResultForNullAndAddExtraDnsError,
  FormResultForNullAndAddMemberToLocalGroupError,
  FormResultForNullAndCreateSplitDnsDomainError,
  FormResultForNullAndCreateSplitDnsResolverErrors,
  FormResultForNullAndDeleteLocalGroupErrors,
  FormResultForNullAndDeleteTagErrors,
  FormResultForNullAndEnableSubnetErrors,
  FormResultForNullAndExtraDnsRecordError,
  FormResultForNullAndSetDeviceDnsnameErrors,
  FormResultForNullAndSetGeneralSettingsErrors,
  FormResultForNullAndSetLdapConnectionSettingsErrors,
  FormResultForNullAndSetLdapSettingsErrors,
  FormResultForNullAndSetTagNameErrors,
  FormResultForNullAndUpdateExtraDnsDomainError,
  FormResultForNullAndUpdateExtraDnsRecordError,
  FormResultForNullAndUpdateGlobalDnsErrors,
  FormResultForNullAndUpdateSplitDnsDomainError,
  FormResultForNullAndUpdateSplitDnsResolverErrors,
  FormResultForSingleUuidAndCreateLocalGroupErrors,
  FormResultForSingleUuidAndCreateTagErrors,
  FormResultForTestLdapSearchResponseAndTestLdapSettingsErrors,
  FullGlobalDns,
  FullLdapSettings,
  FullSubnet,
  FullTag,
  GetAllAccessRuleOptionsResponse,
  GetAllAccessRulesForResponse,
  GetAllDevicesRequest,
  GetAllDevicesResponse,
  GetAllExitNodesRequest,
  GetAllGroupsRequest,
  GetAllPreAuthKeysRequest,
  GetAllSubnetsRequest,
  GetAllTagsRequest,
  GetAllUsersRequest,
  GetChangelogRequest,
  GetGeneralSettingsResponse,
  GetOidcSettingsResponse,
  GetPendingExitNodesRequest,
  GetPendingRoutesRequest,
  GetScimSettingsResponse,
  GetSingleDeviceResponse,
  GetSingleGroupMembersRequest,
  GetSingleGroupResponse,
  GetSingleUserResponse,
  ListForFullAccessRule,
  ListForFullExtraDnsDomain,
  ListForFullSplitDnsDomain,
  ListForSimpleAccount,
  ListForSimpleChangelogEntry,
  ListForSimpleDnsSearchDomain,
  ListForSimpleExtraDnsDomain,
  MoveDnsSearchDomainRequest,
  OptionalForSimpleGroup,
  PageForFullHeadscalePreAuthKey,
  PageForGetAllGroupsResponseItem,
  PageForGetAllSubnetsResponseItem,
  PageForGetExitNodesResponseItem,
  PageForGetPendingRoutesResponseItem,
  PageForSimpleChangelogEntry,
  PageForSimpleTag,
  PageForSimpleUser,
  SetDeviceDnsnameRequest,
  SetGeneralSettingsRequest,
  SetLdapConnectionSettingsRequest,
  SetLdapQuerySettingsRequest,
  SetScimSettingsRequest,
  SetTagDescriptionRequest,
  SetTagNameRequest,
  SingleUuid,
  SubnetsDescriptionRequest,
  UpdateAccessRuleRequest,
  UpdateExtraDnsDomainRequest,
  UpdateExtraDnsRecordRequest,
  UpdateGroupRequest,
  UpdateOidcSettingsRequest,
  UpdateSplitDnsDomainRequest,
  UpdateSplitDnsResolverRequest,
} from '../models/index';

export interface AddDeviceTagRequest {
    uuid: string;
    SingleUuid?: SingleUuid;
}

export interface AddDomainToSplitDnsRequest {
    CreateSplitDnsDomainRequest?: CreateSplitDnsDomainRequest;
}

export interface AddExtraDnsDomainRequest {
    AddExtraDnsRequest?: AddExtraDnsRequest;
}

export interface AddLocalGroupMemberRequest {
    uuid: string;
    SingleUuid?: SingleUuid;
}

export interface AddRecordToExtraDnsRequest {
    uuid: string;
    AddExtraDnsRecordRequest?: AddExtraDnsRecordRequest;
}

export interface AddResolverToDomainInSplitDnsRequest {
    domain_uuid: string;
    CreateSplitDnsResolverRequest?: CreateSplitDnsResolverRequest;
}

export interface ApprovePendingExitNodeRequest {
    uuid: string;
}

export interface ApprovePendingSubnetRouteRequest {
    uuid: string;
    SubnetsDescriptionRequest?: SubnetsDescriptionRequest;
}

export interface CreateAccessRuleOperationRequest {
    CreateAccessRuleRequest?: CreateAccessRuleRequest;
}

export interface CreateLocalGroupOperationRequest {
    CreateLocalGroupRequest?: CreateLocalGroupRequest;
}

export interface CreatePreAuthKeyOperationRequest {
    CreatePreAuthKeyRequest?: CreatePreAuthKeyRequest;
}

export interface CreateTagOperationRequest {
    CreateTagRequest?: CreateTagRequest;
}

export interface DeleteAccessRuleRequest {
    uuid: string;
}

export interface DeleteAccountRequest {
    uuid: string;
}

export interface DeleteDeviceRequest {
    uuid: string;
}

export interface DeleteDomainFromSplitDnsRequest {
    domain_uuid: string;
}

export interface DeleteExitNodeRequest {
    uuid: string;
}

export interface DeleteExtraDnsDomainRequest {
    uuid: string;
}

export interface DeleteExtraDnsRecordRequest {
    uuid: string;
}

export interface DeleteLocalGroupRequest {
    uuid: string;
}

export interface DeleteResolverFromDomainInSplitDnsRequest {
    resolver_uuid: string;
}

export interface DeleteSubnetRequest {
    uuid: string;
}

export interface DeleteTagRequest {
    uuid: string;
}

export interface DisableExitNodeRequest {
    uuid: string;
}

export interface DisableSubnetRequest {
    uuid: string;
}

export interface DumpDeviceStateRequest {
    uuid: string;
}

export interface EditSubnetDescriptionRequest {
    uuid: string;
    SubnetsDescriptionRequest?: SubnetsDescriptionRequest;
}

export interface EnableExitNodeRequest {
    uuid: string;
}

export interface EnableSubnetOperationRequest {
    uuid: string;
    EnableSubnetRequest?: EnableSubnetRequest;
}

export interface ExpireDeviceRequest {
    uuid: string;
}

export interface ExpireKeyRequest {
    uuid: string;
}

export interface ExpireUserRequest {
    uuid: string;
}

export interface GetAllAccessRulesForDeviceRequest {
    uuid: string;
}

export interface GetAllAccessRulesForGroupRequest {
    uuid: string;
}

export interface GetAllAccessRulesForUserRequest {
    uuid: string;
}

export interface GetAllApprovedExitNodesRequest {
    GetAllExitNodesRequest?: GetAllExitNodesRequest;
}

export interface GetAllDevicesOperationRequest {
    GetAllDevicesRequest?: GetAllDevicesRequest;
}

export interface GetAllExtraDnsRequest {
    filter_dns?: string | null;
}

export interface GetAllGroupsOperationRequest {
    GetAllGroupsRequest?: GetAllGroupsRequest;
}

export interface GetAllPreAuthKeysOperationRequest {
    GetAllPreAuthKeysRequest?: GetAllPreAuthKeysRequest;
}

export interface GetAllSubnetsOperationRequest {
    GetAllSubnetsRequest?: GetAllSubnetsRequest;
}

export interface GetAllTagsOperationRequest {
    GetAllTagsRequest?: GetAllTagsRequest;
}

export interface GetAllUsersOperationRequest {
    GetAllUsersRequest?: GetAllUsersRequest;
}

export interface GetChangelogOperationRequest {
    GetChangelogRequest?: GetChangelogRequest;
}

export interface GetDeviceExtraDnsRequest {
    uuid: string;
}

export interface GetDeviceFromIpRequest {
    ip?: string;
}

export interface GetPendingExitNodesOperationRequest {
    GetPendingExitNodesRequest?: GetPendingExitNodesRequest;
}

export interface GetPendingSubnetRoutesRequest {
    GetPendingRoutesRequest?: GetPendingRoutesRequest;
}

export interface GetPossibleExtraDnsForDeviceRequest {
    uuid: string;
}

export interface GetSingleDeviceRequest {
    uuid: string;
}

export interface GetSingleGroupRequest {
    uuid: string;
}

export interface GetSingleGroupMembersOperationRequest {
    uuid: string;
    GetSingleGroupMembersRequest?: GetSingleGroupMembersRequest;
}

export interface GetSingleSubnetRequest {
    uuid: string;
}

export interface GetSingleUserRequest {
    uuid: string;
}

export interface GetTagRequest {
    uuid: string;
}

export interface InsertDnsSearchDomainRequest {
    AddDnsSearchDomainRequest?: AddDnsSearchDomainRequest;
}

export interface MoveDnsSearchDomainOperationRequest {
    MoveDnsSearchDomainRequest?: MoveDnsSearchDomainRequest;
}

export interface RejectPendingExitNodeRequest {
    uuid: string;
}

export interface RejectPendingSubnetRouteRequest {
    uuid: string;
}

export interface RemoveDeviceTagRequest {
    uuid: string;
    SingleUuid?: SingleUuid;
}

export interface RemoveDnsSearchDomainRequest {
    domain_index: number;
}

export interface RemoveLocalGroupMemberRequest {
    uuid: string;
    SingleUuid?: SingleUuid;
}

export interface SetDeviceDnsnameOperationRequest {
    uuid: string;
    SetDeviceDnsnameRequest?: SetDeviceDnsnameRequest;
}

export interface SetGeneralSettingsOperationRequest {
    SetGeneralSettingsRequest?: SetGeneralSettingsRequest;
}

export interface SetLdapConnectionSettingsOperationRequest {
    SetLdapConnectionSettingsRequest?: SetLdapConnectionSettingsRequest;
}

export interface SetLdapQuerySettingsOperationRequest {
    SetLdapQuerySettingsRequest?: SetLdapQuerySettingsRequest;
}

export interface SetPortalAccessGroupRequest {
    SingleUuid?: SingleUuid;
}

export interface SetScimSettingsOperationRequest {
    SetScimSettingsRequest?: SetScimSettingsRequest;
}

export interface SetTagDescriptionOperationRequest {
    tag_uuid: string;
    SetTagDescriptionRequest?: SetTagDescriptionRequest;
}

export interface SetTagNameOperationRequest {
    tag_uuid: string;
    SetTagNameRequest?: SetTagNameRequest;
}

export interface TestLdapQuerySettingsRequest {
    SetLdapQuerySettingsRequest?: SetLdapQuerySettingsRequest;
}

export interface UpdateAccessRuleOperationRequest {
    uuid: string;
    UpdateAccessRuleRequest?: UpdateAccessRuleRequest;
}

export interface UpdateDomainInSplitDnsRequest {
    domain_uuid: string;
    UpdateSplitDnsDomainRequest?: UpdateSplitDnsDomainRequest;
}

export interface UpdateExtraDnsDomainOperationRequest {
    uuid: string;
    UpdateExtraDnsDomainRequest?: UpdateExtraDnsDomainRequest;
}

export interface UpdateExtraDnsRecordOperationRequest {
    uuid: string;
    UpdateExtraDnsRecordRequest?: UpdateExtraDnsRecordRequest;
}

export interface UpdateGlobalDnsRequest {
    FullGlobalDns?: FullGlobalDns;
}

export interface UpdateGroupOperationRequest {
    uuid: string;
    UpdateGroupRequest?: UpdateGroupRequest;
}

export interface UpdateOidcSettingsOperationRequest {
    UpdateOidcSettingsRequest?: UpdateOidcSettingsRequest;
}

export interface UpdateResolverInDomainInSplitDnsRequest {
    resolver_uuid: string;
    UpdateSplitDnsResolverRequest?: UpdateSplitDnsResolverRequest;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     */
    async addDeviceTagRaw(requestParameters: AddDeviceTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling addDeviceTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/devices/{uuid}/add-tag`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SingleUuid'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async addDeviceTag(requestParameters: AddDeviceTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addDeviceTagRaw(requestParameters, initOverrides);
    }

    /**
     * Add new domain to split dns
     * Add new domain to split dns
     */
    async addDomainToSplitDnsRaw(requestParameters: AddDomainToSplitDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndCreateSplitDnsDomainError>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/add-domain`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateSplitDnsDomainRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Add new domain to split dns
     * Add new domain to split dns
     */
    async addDomainToSplitDns(requestParameters: AddDomainToSplitDnsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndCreateSplitDnsDomainError> {
        const response = await this.addDomainToSplitDnsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async addExtraDnsDomainRaw(requestParameters: AddExtraDnsDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndAddExtraDnsError>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/add-extra-dns-domain`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['AddExtraDnsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async addExtraDnsDomain(requestParameters: AddExtraDnsDomainRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndAddExtraDnsError> {
        const response = await this.addExtraDnsDomainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async addLocalGroupMemberRaw(requestParameters: AddLocalGroupMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndAddMemberToLocalGroupError>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling addLocalGroupMember().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/groups/local/{uuid}/add-member`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SingleUuid'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async addLocalGroupMember(requestParameters: AddLocalGroupMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndAddMemberToLocalGroupError> {
        const response = await this.addLocalGroupMemberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async addRecordToExtraDnsRaw(requestParameters: AddRecordToExtraDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndExtraDnsRecordError>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling addRecordToExtraDns().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/{uuid}/add-record-to-extra-dns`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['AddExtraDnsRecordRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async addRecordToExtraDns(requestParameters: AddRecordToExtraDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndExtraDnsRecordError> {
        const response = await this.addRecordToExtraDnsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds new resolver to domain
     * Adds new resolver to domain
     */
    async addResolverToDomainInSplitDnsRaw(requestParameters: AddResolverToDomainInSplitDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndCreateSplitDnsResolverErrors>> {
        if (requestParameters['domain_uuid'] == null) {
            throw new runtime.RequiredError(
                'domain_uuid',
                'Required parameter "domain_uuid" was null or undefined when calling addResolverToDomainInSplitDns().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/add-resolver/{domain_uuid}`.replace(`{${"domain_uuid"}}`, encodeURIComponent(String(requestParameters['domain_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateSplitDnsResolverRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Adds new resolver to domain
     * Adds new resolver to domain
     */
    async addResolverToDomainInSplitDns(requestParameters: AddResolverToDomainInSplitDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndCreateSplitDnsResolverErrors> {
        const response = await this.addResolverToDomainInSplitDnsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async approvePendingExitNodeRaw(requestParameters: ApprovePendingExitNodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling approvePendingExitNode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/exit-nodes/approve-pending-exit-node/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async approvePendingExitNode(requestParameters: ApprovePendingExitNodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.approvePendingExitNodeRaw(requestParameters, initOverrides);
    }

    /**
     */
    async approvePendingSubnetRouteRaw(requestParameters: ApprovePendingSubnetRouteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling approvePendingSubnetRoute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/subnets/approve-pending-route/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SubnetsDescriptionRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async approvePendingSubnetRoute(requestParameters: ApprovePendingSubnetRouteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.approvePendingSubnetRouteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createAccessRuleRaw(requestParameters: CreateAccessRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SingleUuid>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/access-rules/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateAccessRuleRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async createAccessRule(requestParameters: CreateAccessRuleOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SingleUuid> {
        const response = await this.createAccessRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createLocalGroupRaw(requestParameters: CreateLocalGroupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForSingleUuidAndCreateLocalGroupErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/groups/local/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateLocalGroupRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async createLocalGroup(requestParameters: CreateLocalGroupOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForSingleUuidAndCreateLocalGroupErrors> {
        const response = await this.createLocalGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createPreAuthKeyRaw(requestParameters: CreatePreAuthKeyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePreAuthKeyResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/pre-auth-keys/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreatePreAuthKeyRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async createPreAuthKey(requestParameters: CreatePreAuthKeyOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePreAuthKeyResponse> {
        const response = await this.createPreAuthKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createTagRaw(requestParameters: CreateTagOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForSingleUuidAndCreateTagErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/tags/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateTagRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async createTag(requestParameters: CreateTagOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForSingleUuidAndCreateTagErrors> {
        const response = await this.createTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteAccessRuleRaw(requestParameters: DeleteAccessRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteAccessRule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/access-rules/delete/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAccessRule(requestParameters: DeleteAccessRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAccessRuleRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteAccountRaw(requestParameters: DeleteAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/accounts/delete/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAccount(requestParameters: DeleteAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAccountRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteDeviceRaw(requestParameters: DeleteDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/devices/{uuid}/delete`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteDevice(requestParameters: DeleteDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDeviceRaw(requestParameters, initOverrides);
    }

    /**
     * Delete domain from split dns
     * Delete domain from split dns
     */
    async deleteDomainFromSplitDnsRaw(requestParameters: DeleteDomainFromSplitDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['domain_uuid'] == null) {
            throw new runtime.RequiredError(
                'domain_uuid',
                'Required parameter "domain_uuid" was null or undefined when calling deleteDomainFromSplitDns().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/delete-domain/{domain_uuid}`.replace(`{${"domain_uuid"}}`, encodeURIComponent(String(requestParameters['domain_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete domain from split dns
     * Delete domain from split dns
     */
    async deleteDomainFromSplitDns(requestParameters: DeleteDomainFromSplitDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDomainFromSplitDnsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteExitNodeRaw(requestParameters: DeleteExitNodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteExitNode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/exit-nodes/delete-exit-node/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteExitNode(requestParameters: DeleteExitNodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteExitNodeRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteExtraDnsDomainRaw(requestParameters: DeleteExtraDnsDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteExtraDnsDomain().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/{uuid}/delete-extra-dns-domain`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteExtraDnsDomain(requestParameters: DeleteExtraDnsDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteExtraDnsDomainRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteExtraDnsRecordRaw(requestParameters: DeleteExtraDnsRecordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteExtraDnsRecord().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/{uuid}/delete-extra-dns-record`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteExtraDnsRecord(requestParameters: DeleteExtraDnsRecordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteExtraDnsRecordRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteLocalGroupRaw(requestParameters: DeleteLocalGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndDeleteLocalGroupErrors>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteLocalGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/groups/local/delete/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async deleteLocalGroup(requestParameters: DeleteLocalGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndDeleteLocalGroupErrors> {
        const response = await this.deleteLocalGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete resolver
     * Delete resolver
     */
    async deleteResolverFromDomainInSplitDnsRaw(requestParameters: DeleteResolverFromDomainInSplitDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['resolver_uuid'] == null) {
            throw new runtime.RequiredError(
                'resolver_uuid',
                'Required parameter "resolver_uuid" was null or undefined when calling deleteResolverFromDomainInSplitDns().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/delete-resolver/{resolver_uuid}`.replace(`{${"resolver_uuid"}}`, encodeURIComponent(String(requestParameters['resolver_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete resolver
     * Delete resolver
     */
    async deleteResolverFromDomainInSplitDns(requestParameters: DeleteResolverFromDomainInSplitDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteResolverFromDomainInSplitDnsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteSubnetRaw(requestParameters: DeleteSubnetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteSubnet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/subnets/delete-subnet/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteSubnet(requestParameters: DeleteSubnetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSubnetRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteTagRaw(requestParameters: DeleteTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndDeleteTagErrors>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/tags/delete/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async deleteTag(requestParameters: DeleteTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndDeleteTagErrors> {
        const response = await this.deleteTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async disableExitNodeRaw(requestParameters: DisableExitNodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling disableExitNode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/exit-nodes/disable-exit-node/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async disableExitNode(requestParameters: DisableExitNodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.disableExitNodeRaw(requestParameters, initOverrides);
    }

    /**
     */
    async disableSubnetRaw(requestParameters: DisableSubnetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling disableSubnet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/subnets/disable-subnet/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async disableSubnet(requestParameters: DisableSubnetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.disableSubnetRaw(requestParameters, initOverrides);
    }

    /**
     */
    async dumpDeviceStateRaw(requestParameters: DumpDeviceStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling dumpDeviceState().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/devices/{uuid}/dump-state`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async dumpDeviceState(requestParameters: DumpDeviceStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.dumpDeviceStateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async editSubnetDescriptionRaw(requestParameters: EditSubnetDescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling editSubnetDescription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/subnets/edit-subnet-description/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SubnetsDescriptionRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async editSubnetDescription(requestParameters: EditSubnetDescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.editSubnetDescriptionRaw(requestParameters, initOverrides);
    }

    /**
     */
    async enableExitNodeRaw(requestParameters: EnableExitNodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling enableExitNode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/exit-nodes/enable-exit-node/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async enableExitNode(requestParameters: EnableExitNodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.enableExitNodeRaw(requestParameters, initOverrides);
    }

    /**
     */
    async enableSubnetRaw(requestParameters: EnableSubnetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndEnableSubnetErrors>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling enableSubnet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/subnets/enable-subnet/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['EnableSubnetRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async enableSubnet(requestParameters: EnableSubnetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndEnableSubnetErrors> {
        const response = await this.enableSubnetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async expireDeviceRaw(requestParameters: ExpireDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling expireDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/devices/{uuid}/expire`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async expireDevice(requestParameters: ExpireDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.expireDeviceRaw(requestParameters, initOverrides);
    }

    /**
     */
    async expireKeyRaw(requestParameters: ExpireKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling expireKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/pre-auth-keys/{uuid}/expire`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async expireKey(requestParameters: ExpireKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.expireKeyRaw(requestParameters, initOverrides);
    }

    /**
     */
    async expireUserRaw(requestParameters: ExpireUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling expireUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/users/{uuid}/expire`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async expireUser(requestParameters: ExpireUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.expireUserRaw(requestParameters, initOverrides);
    }

    /**
     */
    async exportChangelogRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForSimpleChangelogEntry>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/changelog/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async exportChangelog(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForSimpleChangelogEntry> {
        const response = await this.exportChangelogRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllAccessRuleOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllAccessRuleOptionsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/access-rules/all-for-options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllAccessRuleOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllAccessRuleOptionsResponse> {
        const response = await this.getAllAccessRuleOptionsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllAccessRulesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForFullAccessRule>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/access-rules/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllAccessRules(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForFullAccessRule> {
        const response = await this.getAllAccessRulesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllAccessRulesForDeviceRaw(requestParameters: GetAllAccessRulesForDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllAccessRulesForResponse>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getAllAccessRulesForDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/access-rules/all-for-device/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllAccessRulesForDevice(requestParameters: GetAllAccessRulesForDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllAccessRulesForResponse> {
        const response = await this.getAllAccessRulesForDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllAccessRulesForGroupRaw(requestParameters: GetAllAccessRulesForGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllAccessRulesForResponse>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getAllAccessRulesForGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/access-rules/all-for-group/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllAccessRulesForGroup(requestParameters: GetAllAccessRulesForGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllAccessRulesForResponse> {
        const response = await this.getAllAccessRulesForGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllAccessRulesForUserRaw(requestParameters: GetAllAccessRulesForUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllAccessRulesForResponse>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getAllAccessRulesForUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/access-rules/all-for-user/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllAccessRulesForUser(requestParameters: GetAllAccessRulesForUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllAccessRulesForResponse> {
        const response = await this.getAllAccessRulesForUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllAccountsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForSimpleAccount>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/accounts/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllAccounts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForSimpleAccount> {
        const response = await this.getAllAccountsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllApprovedExitNodesRaw(requestParameters: GetAllApprovedExitNodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForGetExitNodesResponseItem>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/exit-nodes/all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetAllExitNodesRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllApprovedExitNodes(requestParameters: GetAllApprovedExitNodesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForGetExitNodesResponseItem> {
        const response = await this.getAllApprovedExitNodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllDevicesRaw(requestParameters: GetAllDevicesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllDevicesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/devices/all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetAllDevicesRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllDevices(requestParameters: GetAllDevicesOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllDevicesResponse> {
        const response = await this.getAllDevicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllExtraDnsRaw(requestParameters: GetAllExtraDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForFullExtraDnsDomain>> {
        const queryParameters: any = {};

        if (requestParameters['filter_dns'] != null) {
            queryParameters['filter_dns'] = requestParameters['filter_dns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/get-all-extra-dns`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllExtraDns(requestParameters: GetAllExtraDnsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForFullExtraDnsDomain> {
        const response = await this.getAllExtraDnsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllGroupsRaw(requestParameters: GetAllGroupsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForGetAllGroupsResponseItem>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/groups/all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetAllGroupsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllGroups(requestParameters: GetAllGroupsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForGetAllGroupsResponseItem> {
        const response = await this.getAllGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllPreAuthKeysRaw(requestParameters: GetAllPreAuthKeysOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForFullHeadscalePreAuthKey>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/pre-auth-keys/all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetAllPreAuthKeysRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllPreAuthKeys(requestParameters: GetAllPreAuthKeysOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForFullHeadscalePreAuthKey> {
        const response = await this.getAllPreAuthKeysRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllSubnetsRaw(requestParameters: GetAllSubnetsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForGetAllSubnetsResponseItem>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/subnets/all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetAllSubnetsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllSubnets(requestParameters: GetAllSubnetsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForGetAllSubnetsResponseItem> {
        const response = await this.getAllSubnetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllTagsRaw(requestParameters: GetAllTagsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForSimpleTag>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/tags/all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetAllTagsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllTags(requestParameters: GetAllTagsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForSimpleTag> {
        const response = await this.getAllTagsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllUsersRaw(requestParameters: GetAllUsersOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForSimpleUser>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/users/all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetAllUsersRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllUsers(requestParameters: GetAllUsersOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForSimpleUser> {
        const response = await this.getAllUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getChangelogRaw(requestParameters: GetChangelogOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForSimpleChangelogEntry>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/changelog`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetChangelogRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getChangelog(requestParameters: GetChangelogOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForSimpleChangelogEntry> {
        const response = await this.getChangelogRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDeviceExtraDnsRaw(requestParameters: GetDeviceExtraDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForFullExtraDnsDomain>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getDeviceExtraDns().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/{uuid}/get-device-extra-dns`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getDeviceExtraDns(requestParameters: GetDeviceExtraDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForFullExtraDnsDomain> {
        const response = await this.getDeviceExtraDnsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDeviceFromIpRaw(requestParameters: GetDeviceFromIpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeviceFromIpResponse>> {
        const queryParameters: any = {};

        if (requestParameters['ip'] != null) {
            queryParameters['ip'] = requestParameters['ip'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/devices/get-device-from-ip`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getDeviceFromIp(requestParameters: GetDeviceFromIpRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeviceFromIpResponse> {
        const response = await this.getDeviceFromIpRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the list of search domains
     * Retrieves the list of search domains
     */
    async getDnsSearchDomainsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForSimpleDnsSearchDomain>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/get-search-domains`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves the list of search domains
     * Retrieves the list of search domains
     */
    async getDnsSearchDomains(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForSimpleDnsSearchDomain> {
        const response = await this.getDnsSearchDomainsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getGeneralSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetGeneralSettingsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/settings/general`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getGeneralSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetGeneralSettingsResponse> {
        const response = await this.getGeneralSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getGlobalDnsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FullGlobalDns>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/get-global`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getGlobalDns(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FullGlobalDns> {
        const response = await this.getGlobalDnsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getLdapSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FullLdapSettings>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/ldap/get-settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getLdapSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FullLdapSettings> {
        const response = await this.getLdapSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getOidcSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOidcSettingsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/settings/oidc`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getOidcSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOidcSettingsResponse> {
        const response = await this.getOidcSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getPendingExitNodesRaw(requestParameters: GetPendingExitNodesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForGetExitNodesResponseItem>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/exit-nodes/get-pending-exit-nodes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetPendingExitNodesRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getPendingExitNodes(requestParameters: GetPendingExitNodesOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForGetExitNodesResponseItem> {
        const response = await this.getPendingExitNodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPendingSubnetRoutesRaw(requestParameters: GetPendingSubnetRoutesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForGetPendingRoutesResponseItem>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/subnets/get-pending-routes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetPendingRoutesRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getPendingSubnetRoutes(requestParameters: GetPendingSubnetRoutesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForGetPendingRoutesResponseItem> {
        const response = await this.getPendingSubnetRoutesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPortalAccessGroupRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OptionalForSimpleGroup>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/settings/portal-access-group`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getPortalAccessGroup(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OptionalForSimpleGroup> {
        const response = await this.getPortalAccessGroupRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getPossibleExtraDnsForDeviceRaw(requestParameters: GetPossibleExtraDnsForDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForSimpleExtraDnsDomain>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getPossibleExtraDnsForDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/{uuid}/get-possible-extra-dns-for-device`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getPossibleExtraDnsForDevice(requestParameters: GetPossibleExtraDnsForDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForSimpleExtraDnsDomain> {
        const response = await this.getPossibleExtraDnsForDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getScimSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetScimSettingsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/settings/scim`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getScimSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetScimSettingsResponse> {
        const response = await this.getScimSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getSingleDeviceRaw(requestParameters: GetSingleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSingleDeviceResponse>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getSingleDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/devices/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getSingleDevice(requestParameters: GetSingleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSingleDeviceResponse> {
        const response = await this.getSingleDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSingleGroupRaw(requestParameters: GetSingleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSingleGroupResponse>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getSingleGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/groups/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getSingleGroup(requestParameters: GetSingleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSingleGroupResponse> {
        const response = await this.getSingleGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSingleGroupMembersRaw(requestParameters: GetSingleGroupMembersOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForSimpleUser>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getSingleGroupMembers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/groups/{uuid}/members`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetSingleGroupMembersRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getSingleGroupMembers(requestParameters: GetSingleGroupMembersOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForSimpleUser> {
        const response = await this.getSingleGroupMembersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSingleSubnetRaw(requestParameters: GetSingleSubnetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FullSubnet>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getSingleSubnet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/subnets/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getSingleSubnet(requestParameters: GetSingleSubnetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FullSubnet> {
        const response = await this.getSingleSubnetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSingleUserRaw(requestParameters: GetSingleUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSingleUserResponse>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getSingleUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/users/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getSingleUser(requestParameters: GetSingleUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSingleUserResponse> {
        const response = await this.getSingleUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSplitDnsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForFullSplitDnsDomain>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/get-split-dns`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getSplitDns(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForFullSplitDnsDomain> {
        const response = await this.getSplitDnsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getTagRaw(requestParameters: GetTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FullTag>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/tags/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getTag(requestParameters: GetTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FullTag> {
        const response = await this.getTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds a new search domain  # Bad Request - if the domain already is a search domain - if the index is out of bounds - if the domain does not match the regex
     * Adds a new search domain
     */
    async insertDnsSearchDomainRaw(requestParameters: InsertDnsSearchDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/insert-search-domains`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['AddDnsSearchDomainRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Adds a new search domain  # Bad Request - if the domain already is a search domain - if the index is out of bounds - if the domain does not match the regex
     * Adds a new search domain
     */
    async insertDnsSearchDomain(requestParameters: InsertDnsSearchDomainRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.insertDnsSearchDomainRaw(requestParameters, initOverrides);
    }

    /**
     * Moves a search domain from one index to another  This is implemented as a remove followed by an insert. Therefore, the `new_index` references to the list without the domain to move.  # Bad Request - if any index is out of bounds
     * Moves a search domain from one index to another
     */
    async moveDnsSearchDomainRaw(requestParameters: MoveDnsSearchDomainOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/move-search-domains`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['MoveDnsSearchDomainRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Moves a search domain from one index to another  This is implemented as a remove followed by an insert. Therefore, the `new_index` references to the list without the domain to move.  # Bad Request - if any index is out of bounds
     * Moves a search domain from one index to another
     */
    async moveDnsSearchDomain(requestParameters: MoveDnsSearchDomainOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.moveDnsSearchDomainRaw(requestParameters, initOverrides);
    }

    /**
     */
    async openWebsocketRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/websocket`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async openWebsocket(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.openWebsocketRaw(initOverrides);
    }

    /**
     */
    async rejectPendingExitNodeRaw(requestParameters: RejectPendingExitNodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling rejectPendingExitNode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/exit-nodes/reject-pending-exit-node/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async rejectPendingExitNode(requestParameters: RejectPendingExitNodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rejectPendingExitNodeRaw(requestParameters, initOverrides);
    }

    /**
     */
    async rejectPendingSubnetRouteRaw(requestParameters: RejectPendingSubnetRouteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling rejectPendingSubnetRoute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/subnets/reject-pending-route/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async rejectPendingSubnetRoute(requestParameters: RejectPendingSubnetRouteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rejectPendingSubnetRouteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async removeDeviceTagRaw(requestParameters: RemoveDeviceTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling removeDeviceTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/devices/{uuid}/remove-tag`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SingleUuid'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async removeDeviceTag(requestParameters: RemoveDeviceTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeDeviceTagRaw(requestParameters, initOverrides);
    }

    /**
     * Removes a search domain  # Bad Request - if the index is out of bounds
     * Removes a search domain
     */
    async removeDnsSearchDomainRaw(requestParameters: RemoveDnsSearchDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['domain_index'] == null) {
            throw new runtime.RequiredError(
                'domain_index',
                'Required parameter "domain_index" was null or undefined when calling removeDnsSearchDomain().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/remove-search-domains/{domain_index}`.replace(`{${"domain_index"}}`, encodeURIComponent(String(requestParameters['domain_index']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Removes a search domain  # Bad Request - if the index is out of bounds
     * Removes a search domain
     */
    async removeDnsSearchDomain(requestParameters: RemoveDnsSearchDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeDnsSearchDomainRaw(requestParameters, initOverrides);
    }

    /**
     */
    async removeLocalGroupMemberRaw(requestParameters: RemoveLocalGroupMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling removeLocalGroupMember().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/groups/local/{uuid}/remove-member`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SingleUuid'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async removeLocalGroupMember(requestParameters: RemoveLocalGroupMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeLocalGroupMemberRaw(requestParameters, initOverrides);
    }

    /**
     */
    async setDeviceDnsnameRaw(requestParameters: SetDeviceDnsnameOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndSetDeviceDnsnameErrors>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling setDeviceDnsname().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/devices/{uuid}/set-dnsname`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetDeviceDnsnameRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async setDeviceDnsname(requestParameters: SetDeviceDnsnameOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndSetDeviceDnsnameErrors> {
        const response = await this.setDeviceDnsnameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async setGeneralSettingsRaw(requestParameters: SetGeneralSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndSetGeneralSettingsErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/settings/general`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetGeneralSettingsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async setGeneralSettings(requestParameters: SetGeneralSettingsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndSetGeneralSettingsErrors> {
        const response = await this.setGeneralSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async setLdapConnectionSettingsRaw(requestParameters: SetLdapConnectionSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndSetLdapConnectionSettingsErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/ldap/set-connection-settings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetLdapConnectionSettingsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async setLdapConnectionSettings(requestParameters: SetLdapConnectionSettingsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndSetLdapConnectionSettingsErrors> {
        const response = await this.setLdapConnectionSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async setLdapQuerySettingsRaw(requestParameters: SetLdapQuerySettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndSetLdapSettingsErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/ldap/set-query-settings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetLdapQuerySettingsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async setLdapQuerySettings(requestParameters: SetLdapQuerySettingsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndSetLdapSettingsErrors> {
        const response = await this.setLdapQuerySettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async setPortalAccessGroupRaw(requestParameters: SetPortalAccessGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/settings/portal-access-group`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SingleUuid'],
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async setPortalAccessGroup(requestParameters: SetPortalAccessGroupRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.setPortalAccessGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async setScimSettingsRaw(requestParameters: SetScimSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/settings/scim`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetScimSettingsRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async setScimSettings(requestParameters: SetScimSettingsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setScimSettingsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async setTagDescriptionRaw(requestParameters: SetTagDescriptionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tag_uuid'] == null) {
            throw new runtime.RequiredError(
                'tag_uuid',
                'Required parameter "tag_uuid" was null or undefined when calling setTagDescription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/tags/update/{tag_uuid}/description`.replace(`{${"tag_uuid"}}`, encodeURIComponent(String(requestParameters['tag_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetTagDescriptionRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async setTagDescription(requestParameters: SetTagDescriptionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setTagDescriptionRaw(requestParameters, initOverrides);
    }

    /**
     */
    async setTagNameRaw(requestParameters: SetTagNameOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndSetTagNameErrors>> {
        if (requestParameters['tag_uuid'] == null) {
            throw new runtime.RequiredError(
                'tag_uuid',
                'Required parameter "tag_uuid" was null or undefined when calling setTagName().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/tags/update/{tag_uuid}/name`.replace(`{${"tag_uuid"}}`, encodeURIComponent(String(requestParameters['tag_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetTagNameRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async setTagName(requestParameters: SetTagNameOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndSetTagNameErrors> {
        const response = await this.setTagNameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async testLdapQuerySettingsRaw(requestParameters: TestLdapQuerySettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForTestLdapSearchResponseAndTestLdapSettingsErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/ldap/test-query-settings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetLdapQuerySettingsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async testLdapQuerySettings(requestParameters: TestLdapQuerySettingsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForTestLdapSearchResponseAndTestLdapSettingsErrors> {
        const response = await this.testLdapQuerySettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateAccessRuleRaw(requestParameters: UpdateAccessRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling updateAccessRule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/access-rules/update/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateAccessRuleRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateAccessRule(requestParameters: UpdateAccessRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateAccessRuleRaw(requestParameters, initOverrides);
    }

    /**
     * Update domain
     * Update domain
     */
    async updateDomainInSplitDnsRaw(requestParameters: UpdateDomainInSplitDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndUpdateSplitDnsDomainError>> {
        if (requestParameters['domain_uuid'] == null) {
            throw new runtime.RequiredError(
                'domain_uuid',
                'Required parameter "domain_uuid" was null or undefined when calling updateDomainInSplitDns().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/update-domain/{domain_uuid}`.replace(`{${"domain_uuid"}}`, encodeURIComponent(String(requestParameters['domain_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateSplitDnsDomainRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Update domain
     * Update domain
     */
    async updateDomainInSplitDns(requestParameters: UpdateDomainInSplitDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndUpdateSplitDnsDomainError> {
        const response = await this.updateDomainInSplitDnsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateExtraDnsDomainRaw(requestParameters: UpdateExtraDnsDomainOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndUpdateExtraDnsDomainError>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling updateExtraDnsDomain().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/{uuid}/update-extra-dns`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateExtraDnsDomainRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async updateExtraDnsDomain(requestParameters: UpdateExtraDnsDomainOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndUpdateExtraDnsDomainError> {
        const response = await this.updateExtraDnsDomainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateExtraDnsRecordRaw(requestParameters: UpdateExtraDnsRecordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndUpdateExtraDnsRecordError>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling updateExtraDnsRecord().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/records/{uuid}/update-extra-dns-record`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateExtraDnsRecordRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async updateExtraDnsRecord(requestParameters: UpdateExtraDnsRecordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndUpdateExtraDnsRecordError> {
        const response = await this.updateExtraDnsRecordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateGlobalDnsRaw(requestParameters: UpdateGlobalDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndUpdateGlobalDnsErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/update-global`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['FullGlobalDns'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async updateGlobalDns(requestParameters: UpdateGlobalDnsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndUpdateGlobalDnsErrors> {
        const response = await this.updateGlobalDnsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateGroupRaw(requestParameters: UpdateGroupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling updateGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/groups/{uuid}/update`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateGroupRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateGroup(requestParameters: UpdateGroupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateGroupRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateOidcSettingsRaw(requestParameters: UpdateOidcSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/settings/oidc`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateOidcSettingsRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateOidcSettings(requestParameters: UpdateOidcSettingsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateOidcSettingsRaw(requestParameters, initOverrides);
    }

    /**
     * Update resolver
     * Update resolver
     */
    async updateResolverInDomainInSplitDnsRaw(requestParameters: UpdateResolverInDomainInSplitDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndUpdateSplitDnsResolverErrors>> {
        if (requestParameters['resolver_uuid'] == null) {
            throw new runtime.RequiredError(
                'resolver_uuid',
                'Required parameter "resolver_uuid" was null or undefined when calling updateResolverInDomainInSplitDns().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/update-resolver/{resolver_uuid}`.replace(`{${"resolver_uuid"}}`, encodeURIComponent(String(requestParameters['resolver_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateSplitDnsResolverRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Update resolver
     * Update resolver
     */
    async updateResolverInDomainInSplitDns(requestParameters: UpdateResolverInDomainInSplitDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndUpdateSplitDnsResolverErrors> {
        const response = await this.updateResolverInDomainInSplitDnsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
